import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from "react";
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLang } from '../../../actions/config.actions';
import CustomNavDropdown from '../Nav/NavDropdown';

const LANGS = {
  en: { icon: '🇺🇸', code: 'en', text: 'common.header.english' },
  fr: { icon: '🇫🇷', code: 'fr', text: 'common.header.french' },
  es: { icon: '🇪🇸', code: 'es', text: 'common.header.spanish' },
  de: { icon: '🇩🇪', code: 'de', text: 'common.header.german' },
  ja: { icon: '🇯🇵', code: 'ja', text: 'common.header.japanese' },
  pt: { icon: '🇵🇹', code: 'pt', text: 'common.header.portuguese' },
  it: { icon: '🇮🇹', code: 'it', text: 'common.header.italian' },
  ar: { icon: '🇦🇪', code: 'ar', text: 'common.header.arabic' },
  hi: { icon: '🇮🇳', code: 'hi', text: 'common.header.hindi' },
};


const LanguageSelector = ({
  mobile = false,
  activeLanguages = ['en', 'fr', 'es', 'de', 'ja', 'pt', 'it', 'ar', 'hi']
}) => {
  const { t, i18n } = useTranslation();
  const globalLang = useSelector(state => state.config.lang);
  const dispatch = useDispatch();

  const [state, setState] = useState({
    activeLangCode: LANGS[globalLang],
  });

  useEffect(() => {
    i18n.changeLanguage(globalLang);
    document.body.dir = i18n.dir();
    setState({
      ...state,
      activeLangCode: LANGS[globalLang]
    });
  }, [globalLang]);

  const handleChangeLang = useCallback((lang) => {
    dispatch(setLang(lang));
  }, [state]);

  const renderLangsItems = (handleChangeLang) => Object.keys(LANGS)
    .map(lang => {
      if (!activeLanguages.includes(lang)) return;
      return <NavDropdown.Item key={lang}
        className={classNames({
          active: lang === state.activeLangCode.code
        })}
        onClick={() => handleChangeLang(lang)}>
        <span>
          <span className="mr-2">{LANGS[lang].icon}</span>
          <span>{t(LANGS[lang].text)}</span>
        </span>
      </NavDropdown.Item>;
    });
  const Wrapper = mobile ? CustomNavDropdown : NavDropdown;

  const title = mobile
    ? `${t('common.header.change_lang')}: ${state.activeLangCode.icon} ${t(state.activeLangCode.text)}`
    : state.activeLangCode.icon;

  return <Wrapper
    id="navdropdown-lang"
    className={classNames("custom-nav-dropdown language-selector", { "icon-only": !mobile })}
    title={title}
    alignRight={!mobile}>
    {renderLangsItems(handleChangeLang)}
  </Wrapper>;
};

LanguageSelector.propTypes = {
  mobile: PropTypes.bool,
  activeLanguages: PropTypes.arrayOf(PropTypes.string)
};
LanguageSelector.defaultProps = {
  mobile: false
};
export default React.memo(LanguageSelector);
